const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIconImagenes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.04 23.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.54,23H2.5a.5.5,0,0,1-.5-.5v-2a.51.51,0,1,1,1,0V22H22V3h-1.5a.51.51,0,1,1,0-1h2a.5.5,0,0,1,.5.5v20A.5.5,0,0,1,22.54,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.54,21H.5a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0h20a.5.5,0,0,1,.5.5v20A.51.51,0,0,1,20.54,21ZM1,20H20V1H1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,20.86a.51.51,0,0,1-.36-.15L6.38,10.42.89,15.92a.51.51,0,0,1-.71,0,.51.51,0,0,1,0-.71L6,9.36a.51.51,0,0,1,.71,0L17.38,20a.5.5,0,0,1,0,.71A.5.5,0,0,1,17,20.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.43,17.63a.47.47,0,0,1-.35-.15l-5-5-3,3a.5.5,0,0,1-.71,0,.48.48,0,0,1,0-.7l3.31-3.32a.51.51,0,0,1,.71,0l5.35,5.36a.48.48,0,0,1,0,.7A.47.47,0,0,1,20.43,17.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.92,7.42a2.35,2.35,0,1,1,2.35-2.35A2.35,2.35,0,0,1,15.92,7.42Zm0-3.7a1.35,1.35,0,1,0,1.35,1.35A1.35,1.35,0,0,0,15.92,3.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImagenes);
export default __webpack_public_path__ + "static/media/icon_imagenes.536242f35611155314870d5caba50f0d.svg";
export { ForwardRef as ReactComponent };